import ApiConnector from "@/repository/connector";

class Orders {
  async get(params = {}) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(`/v1/orders/queue/`, {
      params,
      paramsSerializer: {
        indexes: null,
      },
    });
    result.value = response.data;
    result.error = response.detail;
    return result;
  }

  async getOne({ id }) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(`/v1/orders/${id}/`);
    result.value = response.data;
    result.error = response.detail;
    return result;
  }

  async createOrder(body) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.post(`/v1/orders/`, body);
    result.value = response.data;
    result.error = response.detail;
    return result;
  }

  async updateOrder(order) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.patch(
      `/v1/orders/${order.id}/`,
      order,
    );
    result.value = response.data;
    result.error = response.detail;
    return result;
  }

  async getWorkTimes(date, id) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(
      `/v1/orders/${id}/available-time/${date}/`,
    );
    result.value = response.data;
    result.error = response.detail;
    return result;
  }

  async getCarMakes(title) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(`/v1/makes/`, {
      params: { title },
    });
    result.value = response.data;
    result.error = response.detail;
    return result;
  }

  async confirmOrder(id, body) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.post(
      `/v1/orders/${id}/place-request/`,
      body,
    );
    result.value = response.data;
    result.error = response.detail;
    return result;
  }

  async addOffers({ id, ids }) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.post(
      `/v1/orders/${id}/offers/`,
      ids,
    );
    result.value = response.data;
    result.error = response.detail;
    return result;
  }

  async removeOffers({ id, ids }) {
    const result = {
      value: null,
      error: null,
    };
    const query = ids
      .map((offerId) => `id=${encodeURIComponent(offerId)}`)
      .join("&");
    const response = await ApiConnector.connector.delete(
      `/v1/orders/${id}/offers/?${query}`,
    );
    result.value = response.data;
    result.error = response.detail;
    return result;
  }

  async patchOffers({ id, payload }) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.patch(
      `/v1/orders/${id}/offers/`,
      payload,
    );
    result.value = response.data;
    result.error = response.detail;
    return result;
  }
}

export default new Orders();
